/**
 * Coming-soon page: scroll-linked color invert + live countdown.
 *
 * Colors invert (and the top bar fades out) fairly early into the first
 * scroll — a fixed fraction of one viewport height — rather than only
 * once the notify section is fully in view. Every color on the page
 * reads from the --cs-bg/--cs-fg tokens (see coming-soon.css), so
 * triggering this early is safe: hero text stays legible throughout
 * because it recolors right along with the background, in one continuous
 * transition instead of a hard cut.
 */
(function () {
  var THRESHOLD_RATIO = 0.18;

  function onScroll() {
    var threshold = window.innerHeight * THRESHOLD_RATIO;
    document.body.classList.toggle('cs-inverted', window.scrollY > threshold);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/**
 * Page load-in: the ribbon and logo are on screen from the very first
 * frame (no entrance treatment), while the headline, giant "Coming Soon"
 * text, and countdown slide up into place in a quick staggered sequence.
 * Timed to settle in ~1.2s total: each line takes 0.9s, with the next
 * line starting 0.15s after the previous one — headline at 0s, ghost
 * text at 0.15s, countdown at 0.3s.
 *
 * These elements start hidden via CSS (see coming-soon.css) so there's no
 * flash of the finished layout before this runs. If GSAP didn't load
 * (CDN hiccup, blocked request) or the visitor prefers reduced motion,
 * they're revealed instantly here instead, so the hidden state never
 * gets stuck.
 */
(function () {
  var elements = [].slice.call(document.querySelectorAll('.cs-headline, .cs-ghost, .cs-countdown'));
  if (!elements.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || typeof window.gsap === 'undefined') {
    elements.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  window.gsap.to(elements, {
    opacity: 1,
    y: 0,
    duration: 0.9,
    ease: 'power3.out',
    stagger: 0.15,
  });
})();

(function () {
  // The success message inside the real email-signup block defaults to a
  // sitewide translation string ("Thanks for subscribing!"), shared with
  // every other email-signup instance in the theme. Swapping it here,
  // scoped to just this page's wrapper, keeps that shared string untouched
  // elsewhere while still letting the coming-soon page show its own
  // release-specific copy (editable in the theme editor).
  var wrap = document.querySelector('.cs-signup-wrap[data-success-message]');
  if (wrap) {
    var messageText = wrap.querySelector('.email-signup__message-text');
    if (messageText) messageText.textContent = wrap.dataset.successMessage;
  }
})();

(function () {
  var el = document.getElementById('cs-countdown');
  if (!el) return;
  var target = new Date(el.dataset.target).getTime();
  var values = {
    d: el.querySelector('[data-unit="d"]'),
    h: el.querySelector('[data-unit="h"]'),
    m: el.querySelector('[data-unit="m"]'),
    s: el.querySelector('[data-unit="s"]'),
  };

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var diff = Math.max(0, target - Date.now());
    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    values.d.textContent = days;
    values.h.textContent = pad(hours);
    values.m.textContent = pad(minutes);
    values.s.textContent = pad(seconds);

    if (diff <= 0) clearInterval(interval);
  }

  tick();
  var interval = setInterval(tick, 1000);
})();
